module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((_vm.weekdays), function(day) {
    return _c('th', {
      staticClass: "weekday"
    }, [_vm._v("\n        " + _vm._s(day) + "\n        ")])
  })], 2), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return (!category.parentId) ? [_c('tr', {
      class: ['categoryRow', category.children && category.showChildren ? 'hasChildren' : '']
    }, [_c('td', {
      staticClass: "categoryName"
    }, [_c('category-details-block', {
      attrs: {
        "category": category
      }
    })], 1), _vm._v(" "), _vm._l((_vm.week), function(day) {
      return _c('td', [_c('static-block-row', {
        attrs: {
          "completed": _vm.getCategoryCompleted(category.id, day, !category.showChildren),
          "quota": _vm.getCategoryQuota(category.id, day, !category.showChildren),
          "color": category.color,
          "size": "small"
        }
      })], 1)
    })], 2), _vm._v(" "), _vm._l((Object.keys(category.children || {})), function(childId) {
      return (category.showChildren) ? [_c('tr', {
        staticClass: "categoryRow subcategoryRow"
      }, [_c('td', {
        staticClass: "categoryName"
      }, [_c('subcategory-details-block', {
        attrs: {
          "categoryId": childId
        }
      })], 1), _vm._v(" "), _vm._l((_vm.week), function(day) {
        return _c('td', [_c('static-block-row', {
          attrs: {
            "completed": _vm.isToday(day) ? Object.keys(_vm.categories[childId].blocks).length : _vm.categories[childId].days[day] || 0,
            "quota": _vm.isActiveDay(_vm.categories[childId].activeDays, day) ? _vm.categories[childId].quota : 0,
            "color": _vm.getCategoryColor(childId),
            "size": "small"
          }
        })], 1)
      })], 2)] : _vm._e()
    })] : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9cb8b410!./~/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/DailyWeekView.vue
// module id = ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-9cb8b410!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./dev/src/views/DailyWeekView.vue
// module chunks = 0